import React, { useState, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import ReportContainer from './ReportContainer';
import ReactModal from 'react-modal';
import styled from 'styled-components';
import CloseIcon from '../../../assets/icons/close.svg?react';

// Centered with flex rather than `transform: translate(-50%, -50%)`: a transformed
// ancestor becomes the containing block for `position: fixed` descendants, which
// would break ReactGrid's cell editor positioning inside the modal.
const customStyles = {
  content: {
    position: 'relative',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    padding: 0,
    border: 'none',
    borderRadius: '6px'
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: '9999',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};

export default function Report() {
  const [isOpen, setIsOpen] = useState(false);
  const [isMultiFunds, setIsMultiFunds] = useState(true);
  const [reportKey, setReportKey] = useState(0);
  const modalRef = useRef();
  const [searchParams, setSearchParams] = useSearchParams();
  const reportTypeKey = searchParams.get('type') || 'default';

  const onOpen = () => {
    setIsOpen(true);
    document.body.style.overflow = 'hidden';

    const next = new URLSearchParams(searchParams);
    next.set('staticTemplateModalState', 'open');
    setSearchParams(next, { replace: false });
  };

  const onClose = () => {
    setIsOpen(false);
    document.body.style.overflow = 'initial';
    setReportKey(prev => prev + 1);

    const next = new URLSearchParams(searchParams);
    next.set('staticTemplateModalState', 'closed');
    setSearchParams(next, { replace: false });
  };

  const handleChangeIsMultiFunds = value => {
    setIsMultiFunds(value);
  };

  return (
    <>
      {!isOpen && (
        <ReportContainer
          id="formpf-report-main"
          key={`report-${reportKey}`}
          onOpen={onOpen}
          isMultiFunds={isMultiFunds}
          handleChangeIsMultiFunds={handleChangeIsMultiFunds}
        />
      )}
      <ReactModal
        id="formpf-report-modal"
        isOpen={isOpen}
        onRequestClose={onClose}
        style={customStyles}
      >
        <Wrapper id="formpf-report-modal-wrapper">
          <ReportWrapper id="formpf-report-modal-content" ref={modalRef}>
            <ReportContainer
              id="formpf-report-modal-container"
              key={`report-2-${reportTypeKey}`}
              onClose={onClose}
              isStaticTemplate={true}
              onOpen={onOpen}
              modalRef={modalRef}
              isMultiFunds={isMultiFunds}
              handleChangeIsMultiFunds={handleChangeIsMultiFunds}
            />
          </ReportWrapper>
          <CloseButton id="formpf-report-modal-close-button" onClick={onClose}>
            <CloseIcon />
          </CloseButton>
        </Wrapper>
      </ReactModal>
    </>
  );
}

export const CloseButton = styled.div`
  display: flex;
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  svg {
    width: 24px;
    height: 24px;
  }
`;

export const ReportWrapper = styled.div`
  height: 92%;
  overflow: auto;
`;

export const Wrapper = styled.div`
  min-width: 90vw;
  width: 90vw;
  border-radius: 6px;
  background-color: #fff;
  /* padding: 12px 8px; */
  overflow: auto;
  height: 85vh;
  position: relative;
`;
